import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
	ModuleGroupPermissionPayload,
	ModuleGroupPermissionAddPayload,
	ModuleGroupPermissionUpdatePayload
} from './module-group-permission.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ModuleGroupPermissionService {

	private token!: string;
	private httpOptions: any;

	private basePath = environment.interop.basePath;
	private getModuleGroupPermissionsDTUrl = this.basePath + environment.interop.platform.app.settings.moduleGroupPermission.getModuleGroupPermissionsDT;
	private storeModuleGroupPermissionUrl = this.basePath + environment.interop.platform.app.settings.moduleGroupPermission.storeModuleGroupPermission;
	private putModuleGroupPermissionUrl = this.basePath + environment.interop.platform.app.settings.moduleGroupPermission.putModuleGroupPermission;
	private deleteModuleGroupPermissionUrl = this.basePath + environment.interop.platform.app.settings.moduleGroupPermission.deleteModuleGroupPermission;

	private getModuleGroupPermissionsUrl = this.basePath + environment.interop.platform.app.settings.moduleGroupPermission.getModuleGroupPermissions;

	private getModuleGroupPermissionsRootUrl = this.basePath + environment.interop.platform.app.settings.moduleGroupPermission.getModuleGroupPermissionsRoot;

	constructor(private http: HttpClient) { }

	getModules() {
		return this.http
			.get<{ errors: boolean; data: any[]; status_code: number }>(
				this.getModuleGroupPermissionsUrl
			)
			.pipe(
				map((response) =>
					response.data.map((item) => ({ id: item.id, name: item.name }))
				),
				catchError((error) => {
					console.error('Error in getUsers:', error);
					return throwError(error);
				})
			);
	}

	getModulesNoParent() {
		return this.http
			.get<{ errors: boolean; data: any[]; status_code: number }>(
				this.getModuleGroupPermissionsRootUrl
			)
			.pipe(
				map((response) =>
					response.data.map((item) => ({ id: item.id, name: item.name }))
				),
				catchError((error) => {
					console.error('Error in getUsers:', error);
					return throwError(error);
				})
			);
	}

	getModulesDT() {
		return this.http.get(this.getModuleGroupPermissionsDTUrl, this.httpOptions);
	}

	addModule(data: ModuleGroupPermissionAddPayload) {
		return this.http.post(this.storeModuleGroupPermissionUrl, data, this.httpOptions);
	}

	updateModule(data: ModuleGroupPermissionUpdatePayload) {
		return this.http.put(this.putModuleGroupPermissionUrl, data, this.httpOptions);
	}

	deleteModule(id: number) {
		return this.http.delete(this.deleteModuleGroupPermissionUrl + id, this.httpOptions);
	}

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${this.token}`,
			}),
		};
	}

}
